import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import axios from 'axios';
import { toast } from 'sonner';
import { Link } from 'react-router-dom';

const API = `${window.location.origin}/api`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      toast.error('Por favor, ingresa tu email');
      return;
    }

    setIsLoading(true);

    try {
      const response = await axios.post(`${API}/auth/forgot-password`, {
        email: email
      });

      if (response.data.success) {
        setEmailSent(true);
        toast.success('Email enviado exitosamente');
      }
    } catch (error) {
      console.error('Error sending reset email:', error);
      toast.error(error.response?.data?.detail || 'Error enviando email de recuperación');
    } finally {
      setIsLoading(false);
    }
  };

  if (emailSent) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
        <Card className="w-full max-w-md shadow-xl">
          <CardHeader className="text-center bg-gradient-to-r from-green-500 to-green-600 text-white">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="fas fa-check text-green-500 text-2xl"></i>
            </div>
            <CardTitle className="text-2xl">Email Enviado</CardTitle>
          </CardHeader>
          <CardContent className="p-6 text-center">
            <p className="text-gray-600 mb-6">
              Si el email <strong>{email}</strong> existe en nuestro sistema, 
              recibirás un enlace de recuperación de contraseña.
            </p>
            
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
              <div className="flex items-start">
                <i className="fas fa-info-circle text-blue-500 mt-1 mr-3"></i>
                <div className="text-left">
                  <h4 className="font-semibold text-blue-800 mb-1">Próximos pasos:</h4>
                  <ul className="text-sm text-blue-600 space-y-1">
                    <li>• Revisa tu bandeja de entrada</li>
                    <li>• Haz clic en el enlace del email</li>
                    <li>• El enlace expira en 1 hora</li>
                    <li>• Revisa también la carpeta de spam</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="space-y-3">
              <Button
                onClick={() => setEmailSent(false)}
                variant="outline"
                className="w-full"
              >
                <i className="fas fa-arrow-left mr-2"></i>
                Enviar a otro email
              </Button>
              
              <Link to="/app">
                <Button className="w-full instituto-gradient text-white">
                  <i className="fas fa-sign-in-alt mr-2"></i>
                  Volver al Login
                </Button>
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
      <Card className="w-full max-w-md shadow-xl">
        <CardHeader className="text-center bg-gradient-to-r from-blue-500 to-indigo-600 text-white">
          <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="fas fa-key text-blue-500 text-2xl"></i>
          </div>
          <CardTitle className="text-2xl">Recuperar Contraseña</CardTitle>
          <p className="text-blue-100 mt-2">
            Instituto Bíblico Apostólico del Uruguay
          </p>
        </CardHeader>
        <CardContent className="p-6">
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
            <div className="flex items-start">
              <i className="fas fa-exclamation-triangle text-yellow-500 mt-1 mr-3"></i>
              <div>
                <h4 className="font-semibold text-yellow-800 mb-1">¿Olvidaste tu contraseña?</h4>
                <p className="text-sm text-yellow-700">
                  Ingresa tu email y te enviaremos un enlace seguro para 
                  restablecer tu contraseña.
                </p>
              </div>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Email Institucional</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tu@instituto.uy"
                required
                className="w-full"
                disabled={isLoading}
              />
            </div>

            <Button
              type="submit"
              disabled={isLoading || !email}
              className="w-full instituto-gradient text-white font-semibold py-3"
            >
              <i className={`fas ${isLoading ? 'fa-spinner fa-spin' : 'fa-paper-plane'} mr-2`}></i>
              {isLoading ? 'Enviando...' : 'Enviar Enlace de Recuperación'}
            </Button>
          </form>

          <div className="mt-6 text-center space-y-3">
            <div className="flex items-center justify-center">
              <div className="border-t border-gray-300 flex-1"></div>
              <span className="px-4 text-sm text-gray-500">¿Recordaste tu contraseña?</span>
              <div className="border-t border-gray-300 flex-1"></div>
            </div>
            
            <Link to="/app">
              <Button variant="outline" className="w-full">
                <i className="fas fa-arrow-left mr-2"></i>
                Volver al Login
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ForgotPassword;